"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}require("react"),e(require("styled-components")).default.span`
    display: flex;
    gap: 4px;
    align-items: center;
`;
//# sourceMappingURL=Heart.js.map
